
import Vue from "vue";
import { UserInfo } from "@/models/dossier/user-info";
import { AuthService } from "@/services";
import { isIpAddressValid } from "@/utils/strings";
export default Vue.extend({
	props: {
		user: {
			type: Object as ()=>UserInfo,
			required: true
		}
	},
	methods: {
		async addIp(){
			let myIp = await AuthService.getMyIp();
			this.user.RestrictedToIPAddresses.push(myIp);
		},
		removeIp(i:number){
			this.user.RestrictedToIPAddresses.splice(i, 1);
		},
		isIpValid(value:string):boolean{
			return isIpAddressValid(value);
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});

